// Administração > Comunicação > Mensagem de Boas-Vindas. Backend próprio
// (2026-08-28), mesma permissão granular de identidade visual/integrações
// (administracao.comunicacao, ver requirePermission em permission.guard.ts
// no backend).
import { gpsDriveGet, gpsDrivePut } from "@/lib/api/gpsdrive-client";

export interface WelcomeMessageSettings {
  initialMessage: string;
  loginUrl: string | null;
  sendVehicleData: boolean;
  sendAppLinks: boolean;
  appleStoreUrl: string | null;
  googlePlayUrl: string | null;
  appsMessage: string | null;
  contactsMessage: string | null;
  emergencyPhone: string | null;
  supportWhatsapp: string | null;
  finalMessage: string | null;
}

export type UpdateWelcomeMessageInput = WelcomeMessageSettings;

export const gpsDriveWelcomeMessageService = {
  get: () => gpsDriveGet<WelcomeMessageSettings>("/api/v1/admin/welcome-message"),
  update: (input: UpdateWelcomeMessageInput) =>
    gpsDrivePut<WelcomeMessageSettings>("/api/v1/admin/welcome-message", input),
};
